import React, { useEffect, useState } from "react";
import { VendorRequestAction } from "../../../constants/AppConstants";
import useStyles from "./SapVendorSearch.css";
import translation from "../../../i18n/i18.json";
import { VendorBlockData } from "../../../reducers/vendor/VendorBlockDataReducer";
import {
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { Company } from "../../../models/Company";
import AllActions from "../../../actions";
import { useHistory, useLocation } from "react-router-dom";
import {
  InforDisplyaDuration,
  VendorForm1Modes,
  VendorRequestViewMode,
  NavigationPaths,
  SCF_ALLOWED_COMPANY_CODES,
  AppApprovalPoints,
  VendorTypeData
} from "../../../constants/AppConstants";
import { useDispatch, useSelector } from "react-redux";
import SapVendorSearchComp from "../../../components/Vendor/SapVendorSearch/SapVendorSearch";
import { SAPVendor } from "../../../models/SAPVendor";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { VendorMasterData } from "../../../services/VendorMasterData";
import { ApprovalPointUtil } from "../../../utils/ApprovalPointUtil";
import { RootState } from "../../../reducers";
import { off } from "process";

interface SapVendorSearchProp {
  handleClose: any;
  open: boolean;
  title: string;
  isEditmode: boolean;
  companyCode?: string;
  // companyCodeList: Array<Company>;
  onUpdateConfirm: any;
  alreadySelectedVendors: string[];
  nodataMsg: string;
  maxSelectItems?: number;
  requestMode: VendorForm1Modes | VendorRequestViewMode;
  currentRequestVendor?: string;
}

interface VendorSearchParams {
  companyCode: string;
  vendorName: string;
  vendorNo: string;
}

// interface ChipData {
//   key: number;
//   label: string;
// }

/* export enum VendorRequestAction {
  VIEW = "VIEW",
  AMEND = "AMEND",
  EXTEND = "EXTEND",
  BLOCK = "BLOCK",
  INDIVIDUAL_PAY = "INDIVIDUAL_PAY",
} */



const getAllowedActions = (row: SAPVendor): VendorRequestAction[] => {
  const actions: VendorRequestAction[] = [];

  if (row.canView) actions.push(VendorRequestAction.VIEW);
  if (row.canAmend) actions.push(VendorRequestAction.AMEND);
  if (row.canExtend) actions.push(VendorRequestAction.EXTEND);
  if (row.canBlock) actions.push(VendorRequestAction.BLOCK);
  if (row.canIndividualPay) actions.push(VendorRequestAction.INDIVIDUAL_PAY);

  return actions;
};


export default function SapVendorSearch(props: any) {
  const classes = useStyles();
  const history = useHistory();

  const dispatch = useDispatch();
  const {
    open,
    handleClose,
    title,
    isEditmode,
    companyCode,
    onUpdateConfirm,
    alreadySelectedVendors,
    nodataMsg,
    maxSelectItems,
    requestMode,
    currentRequestVendor,
  } = props.location.state;
  const initialState: VendorSearchParams = {
    companyCode: "",
    vendorName: "",
    vendorNo: "",
  };
  // const BlockVendorData: VendorBlockData = useSelector<RootState, VendorBlockData>((state) => state.vendorBlockData);
  const [filterParams, setFilterParams] = useState(initialState);
  const [vendorListItems, setVendorListItems] = useState<SAPVendor[]>([]);
  const [isTableLoading, setIsTableLoading] = React.useState(false);

  const tableColumnData = Array<any>();

  if (isEditmode) {
    tableColumnData.splice(0, 0, { name: "" });
    tableColumnData.push({ name: translation.vendordetail_vendor_select_popup_cocode });
    tableColumnData.push({ name: translation.vendordetail_vendor_select_popup_poCode });
    tableColumnData.push({ name: translation.vendordetail_vendor_select_popup_sapvendorno });
    tableColumnData.push({ name: translation.vendordetail_vendor_select_popup_country });
    tableColumnData.push({ name: translation.vendordetail_vendor_select_popup_vendorname });
  } else {
    tableColumnData.push({ name: translation.vendordetail_vendor_select_popup_sapvendorno });
  }

  //const [chipData, setChipData] = React.useState<ChipData[]>([]);
  const [selectedVendor, setSelectedVendor] = React.useState<SAPVendor>();
  const [relatedVendorCompanies, setRelatedVendorCompanies] = React.useState<SAPVendor[]>();
  console.log(selectedVendor)

  const prepareForRequest = () => {
    dispatch(AllActions.backDropActions.openBackDrop());
  };

  const compeleteRequest = (
    success: boolean,
    message?: string,
    duration?: number
  ) => {
    dispatch(AllActions.backDropActions.closeBackDrop());
    if (message) {
      let messageduration = duration ? duration : InforDisplyaDuration.common;
      if (success) {
        dispatch(
          AllActions.infoActions.openInforSuccess(message, messageduration!)
        );
      } else {
        dispatch(
          AllActions.infoActions.openInforError(message, messageduration!)
        );
      }
    }
  };
  const onVendorBlockDataSubmit = (vendorRequestData: VendorBlockData) => {
    dispatch({
      type: "ON_CHANGE_VENDOR_BLOCK_DATA",
      payload: vendorListItems,
    });
    //setIsCategoryManager(vendorRequestData.IsCategoryManager);
    //getInitialMetaData(vendorRequestData);
  };


  useEffect(() => {
    if (isTableLoading) {
      getVendorList();
    }
  }, [isTableLoading]);

  const getVendorList = () => {
    prepareForRequest();
    VendorMasterData.GetSAPVendorList(
      {
        companyCode: filterParams!.companyCode,
        vendorNo: filterParams!.vendorNo,
        vendorName: filterParams!.vendorName,
      },
      (result: Array<SAPVendor>) => {
        if (result && result.length > 0) {
          let array: any = result;
          //let flags = [],
          let uniqueVendorList = [],
            l = array.length,
            i;
          for (i = 0; i < l; i++) {
            //if (flags[array[i].vendor]) continue;
            if (
              requestMode === VendorForm1Modes.VendorInialExtend ||
              requestMode === VendorRequestViewMode.VendorAmend
            ) {
              if (currentRequestVendor && array[i].vendor === currentRequestVendor)
                continue;
            }
            //flags[array[i].vendor] = true;
            uniqueVendorList.push(array[i]);
          }

          setVendorListItems(uniqueVendorList);
          compeleteRequest(true);
        } else {
          setVendorListItems([]);
          compeleteRequest(
            false,
            translation.vendordetail_vendor_select_popup_nodata_err
          );
        }
        setIsTableLoading(false);
      },
      (error) => {
        compeleteRequest(
          false,
          translation.vendordetail_vendor_select_popup_data_searcerr
        );
        setIsTableLoading(false);
        setVendorListItems([]);
      }
    );
  };

  const onConfirmSelect = (mode: VendorForm1Modes) => {
    if (!selectedVendor || !selectedVendor.vendor) {
      return;
    }

    const allowedActions = getAllowedActions(selectedVendor);

    history.push(NavigationPaths.VendorRequest, {
      mode,
      sapVendorNo: selectedVendor.vendor,
      companyCode: selectedVendor.compCode,
      poCodes: selectedVendor.poCodes,
      allowedActions, // ✅ safe now
      isView: true, // ✅ REQUIRED
      relatedVendorCompanies: relatedVendorCompanies
    });
  };

  const onSelectVendor = (items: SAPVendor[], relatedCompanies: SAPVendor[]) => {
    setSelectedVendor(items[0]);
    setRelatedVendorCompanies(relatedCompanies);
  };

  const isScfAllowed = (companyCode: string): boolean => {
    return SCF_ALLOWED_COMPANY_CODES.includes(companyCode)
  }

  return (
    <div>
      <Grid
        container
        spacing={2}
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        className={classes.createHeader}
      >
        <span className={classes.createHeaderTxt}>
          {translation.vendordetail_vendor_select_section_title}
        </span>
        <span className={classes.createHeaderLine}></span>
      </Grid>
      <Grid
        //container
        //spacing={2}
        item
      //xs={12}
      //sm={12}
      //md={12}
      //lg={12}
      >
        <SapVendorSearchComp
          isEditmode={true}
          nodataMsg={translation.vendordetail_vendor_select_popup_nodata_msg}
          onVendorSelect={onSelectVendor}
          alreadySelectedVendors={[]}
          maxSelectItems={1}
        />
        <div style={{ margin: "18px 25px 0 0px" }}>
          <div style={{ margin: "20px ​10px 15px 0" }}>
            {selectedVendor && selectedVendor.isUserPermittedCompany && (//TODO : tmp remove until ACME golive
              <div className={classes.greenBtnWrapper}>
                <Button onClick={() => { onConfirmSelect(VendorForm1Modes.VendorInialAmend) }} color="primary">
                  <CheckCircleIcon></CheckCircleIcon>
                  {translation.vendordetail_vendor_select_amend_btn}
                </Button>
              </div>)}

            {
              selectedVendor &&
              selectedVendor.isUserPermittedCompany &&
              (!selectedVendor.isBlockAllCompay && !selectedVendor.isBlockSelectedCompany && !selectedVendor.isBlockSelectedPurchOrg && !selectedVendor.isBlockAllPurchOrg) &&
              isScfAllowed(selectedVendor.compCode) &&
              (selectedVendor.vendorTypeCode === VendorTypeData.RMProductionRelated || selectedVendor.vendorTypeCode === VendorTypeData.AffiliatedVendorsWithinMAS) &&
              ApprovalPointUtil.isUserPermitedApprovalPoint(selectedVendor.compCode, [AppApprovalPoints.VInvVendorInitial]) &&
              (
                <div className={classes.blueBtnWrapper}>
                  <Button onClick={() => { onConfirmSelect(VendorForm1Modes.VendorInitialIndividualPay) }} color="primary">
                    <CheckCircleIcon></CheckCircleIcon>
                    {translation.vendordetail_vendor_select_individual_payment_btn}
                  </Button>
                </div>
              )}

            {selectedVendor && (//TODO : tmp remove until ACME golive
              <div className={classes.blueBtnWrapper}>
                <Button onClick={() => { onConfirmSelect(VendorForm1Modes.VendorInialExtend) }} color="primary">
                  <CheckCircleIcon></CheckCircleIcon>
                  {translation.vendordetail_vendor_select_extend_btn}
                </Button>
              </div>)}

            {selectedVendor && selectedVendor.isUserPermittedCompany && (//TODO : tmp remove until ACME golive
              <div className={classes.redBtnWrapper}>
                <Button onClick={() => { onConfirmSelect(VendorForm1Modes.VendorInialBlock) }} color="primary">
                  <CheckCircleIcon></CheckCircleIcon>
                  {translation.vendordetail_vendor_select_block_btn}
                </Button>
              </div>)}
          </div>
        </div>
      </Grid>
    </div>
  );
}
